<template>
  <div id="instructions-list">
    <ol v-if="selectedStore === PaymentMethod.oxxo">
      <li class="instructions-element">
        {{ t("OXXOINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("OXXOINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("OXXOINSTRUCTIONTHREE") }}
      </li>
      <li class="instructions-element">
        {{ t("OXXOINSTRUCTIONFOUR") }}
      </li>
    </ol>
    <ol v-if="selectedStore === PaymentMethod.spei">
      <li class="instructions-element">
        {{ t("SPEIINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("SPEIINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("SPEIINSTRUCTIONTHREE") }}
      </li>
      <li class="instructions-element">
        {{ t("SPEIINSTRUCTIONFOUR") }}
      </li>
    </ol>
    <ol v-if="selectedStore === PaymentMethod.store">
      <li class="instructions-element">
        {{ t("STOREINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("STOREINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("STOREINSTRUCTIONTHREE") }}
      </li>
      <li class="instructions-element">
        {{ t("STOREINSTRUCTIONFOUR") }}
      </li>
    </ol>
    <ol v-if="selectedStore === PaymentMethod.codi">
      <li class="instructions-element">
        {{ t("CODIINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("CODIINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("CODIINSTRUCTIONTHREE") }}
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { PaymentMethod } from "@/apps/credit-line/types/payment";

const { t } = useI18n();
const selectedStore = inject("selectedStore");
</script>

<style scoped lang="scss"></style>
